export const siteInfo = {
  name: '爆料专区',
  tagline: '擦边视频与擦边图片福利合集',
  description: '爆料专区🎯每日精选擦边视频、擦边图片及各类福利合集，专业编辑团队全天候追踪全网劲爆尺度内容。火辣但不露骨，满足你的猎奇与视觉刺激需求。每日更新，内容覆盖街拍、热舞、精选图集等多个品类，是视觉爱好者的每日必刷站。',
  stats: [
    { label: '每日更新', value: '200+', icon: 'ri-flashlight-line' },
    { label: '精选内容', value: '50,000+', icon: 'ri-image-line' },
    { label: '活跃用户', value: '800万+', icon: 'ri-user-heart-line' },
  ],
};

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '最新快讯', href: '#updates' },
  { label: '热度榜单', href: '#ranking' },
  { label: '用户热议', href: '#comments' },
  { label: '精选推荐', href: '#cards' },
  { label: '联系我们', href: '#contact' },
];

export const comments = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20avatar%20with%20stylish%20makeup%20and%20modern%20hairstyle%2C%20clean%20studio%20lighting%20on%20warm%20neutral%20background%2C%20professional%20headshot%20style%2C%20natural%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '烈焰红唇',
    time: '3 分钟前',
    content: '每天都要来刷一遍，内容太顶了！小编选图眼光真的毒辣，每张都是精品中的精品，这审美我服气！',
    likes: 2847,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Attractive%20Chinese%20female%20portrait%20avatar%20with%20elegant%20look%20and%20long%20dark%20hair%2C%20soft%20studio%20lighting%20on%20warm%20neutral%20background%2C%20professional%20headshot%20style%2C%20friendly%20smile&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '深夜不关机',
    time: '15 分钟前',
    content: '终于找到组织了！这才是真正懂我们的站，火辣但不低俗，尺度拿捏得刚刚好，已设为浏览器首页。',
    likes: 1956,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%20avatar%20with%20trendy%20style%20and%20shoulder%20length%20hair%2C%20warm%20studio%20lighting%20on%20neutral%20background%2C%20professional%20headshot%2C%20confident%20expression&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '视觉猎人',
    time: '28 分钟前',
    content: '更新速度真的快，每天早上打开都有新惊喜，通勤路上全靠它续命了，已推荐给所有兄弟。',
    likes: 1623,
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20portrait%20avatar%20with%20modern%20fashionable%20look%20and%20sleek%20dark%20hair%2C%20clean%20studio%20lighting%20on%20warm%20neutral%20background%2C%20professional%20headshot%2C%20charming%20smile&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '午夜飞行',
    time: '42 分钟前',
    content: '朋友推荐的，进来就出不去了。这个站必须收藏，内容质量和更新频率秒杀同类站点，良心推荐！',
    likes: 1389,
  },
];

export const features = [
  {
    icon: 'ri-star-line',
    title: '每日精选',
    desc: '专业编辑团队每天手工筛选全网最火辣的擦边视频与图片，拒绝机器搬运，只推精品中的精品。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '所有擦边图片与视频均为高清无水印资源，视觉效果拉满，给你最纯净的视觉享受体验。',
  },
  {
    icon: 'ri-rocket-line',
    title: '极速更新',
    desc: '全天候追踪各大平台最新劲爆内容，擦边福利第一时间推送，让你永远走在资讯最前沿。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全合规',
    desc: '严格把控内容尺度，火辣但不露骨，所有擦边内容均在合法合规范围内，安心浏览无风险。',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '今日最火辣擦边视频合集',
    views: '128.6万',
    duration: '12:35',
    thumbnail: 'https://readdy.ai/api/search-image?query=Vibrant%20colorful%20neon%20club%20atmosphere%20with%20energetic%20dance%20vibes%2C%20abstract%20artistic%20motion%20blur%20effect%2C%20hot%20pink%20and%20warm%20orange%20lighting%2C%20stylish%20modern%20aesthetic%2C%20glamorous%20nightlife%20scene%2C%20soft%20focus%20background%20with%20bokeh%20lights&width=640&height=360&seq=media-01&orientation=landscape',
    tag: '热舞',
  },
  {
    id: 2,
    title: '街拍精选 · 第 88 期',
    views: '96.3万',
    duration: '08:21',
    thumbnail: 'https://readdy.ai/api/search-image?query=Fashionable%20urban%20street%20style%20photography%20scene%20with%20warm%20sunset%20golden%20hour%20lighting%2C%20modern%20city%20background%20with%20trendy%20vibe%2C%20elegant%20and%20stylish%20atmosphere%2C%20soft%20warm%20tones%2C%20editorial%20fashion%20photography%20style&width=640&height=360&seq=media-02&orientation=landscape',
    tag: '街拍',
  },
  {
    id: 3,
    title: '热舞合集 · 每日精选',
    views: '215.7万',
    duration: '15:42',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dynamic%20energetic%20dance%20performance%20atmosphere%20with%20vibrant%20stage%20lighting%20in%20warm%20red%20and%20gold%20tones%2C%20dramatic%20spotlight%20effect%2C%20exciting%20club%20vibe%2C%20artistic%20motion%20capture%2C%20entertaining%20nightlife%20scene&width=640&height=360&seq=media-03&orientation=landscape',
    tag: '热舞',
  },
  {
    id: 4,
    title: '福利图集 · 每日更新精选',
    views: '89.2万',
    duration: '06:58',
    thumbnail: 'https://readdy.ai/api/search-image?query=Artistic%20glamorous%20photography%20collection%20atmosphere%20with%20soft%20romantic%20lighting%20in%20warm%20rose%20and%20coral%20tones%2C%20elegant%20studio%20setup%20with%20dreamy%20aesthetic%2C%20fashion%20editorial%20style%2C%20beautiful%20composition%20with%20gentle%20shadows&width=640&height=360&seq=media-04&orientation=landscape',
    tag: '图集',
  },
];

export const rankingItems = [
  { rank: 1, title: '本周最辣街拍合集·夏日特辑', heat: '🔥 285.6万', tag: '街拍', change: 'up' },
  { rank: 2, title: '热舞精选·第 126 期劲爆内容', heat: '🔥 231.2万', tag: '热舞', change: 'up' },
  { rank: 3, title: '擦边图片每日福利·周三特供', heat: '🔥 198.7万', tag: '图集', change: 'down' },
  { rank: 4, title: '健身达人·运动风擦边视频合集', heat: '🔥 176.3万', tag: '视频', change: 'up' },
  { rank: 5, title: '网红精选·本月最火擦边图片', heat: '🔥 152.9万', tag: '图集', change: 'up' },
  { rank: 6, title: 'Cosplay专区·角色扮演福利', heat: '🔥 134.1万', tag: 'Cosplay', change: 'new' },
];

export const updates = [
  { time: '刚刚', title: '🔥 今日擦边视频合集已更新，新增 36 部精选内容，街拍+热舞双料大放送', tag: '最新' },
  { time: '12 分钟前', title: '📸 擦边图片专区上新 128 张高清福利图，夏日清凉主题不容错过', tag: '图集' },
  { time: '28 分钟前', title: '🎬 热舞精选第 127 期上线，本期主打韩系女团风擦边视频', tag: '热舞' },
  { time: '1 小时前', title: '💃 街拍栏目本周数据出炉，最受欢迎擦边内容 TOP10 揭晓', tag: '街拍' },
  { time: '2 小时前', title: '🏆 本月福利合集大盘点，编辑精选 50 部最火辣擦边视频不容错过', tag: '精选' },
  { time: '3 小时前', title: '🎯 Cosplay 专题今日上线，角色扮演擦边图片福利大放送', tag: 'Cosplay' },
  { time: '5 小时前', title: '📊 上周全站数据报告：擦边视频播放量突破 1.2 亿次，创历史新高', tag: '数据' },
];

export const aboutContent = {
  title: '关于爆料专区',
  content: '爆料专区成立于 2023 年，是国内领先的擦边视频与擦边图片福利合集平台。我们拥有一支经验丰富的编辑团队，全天候追踪全网最火辣、最具视觉冲击力的劲爆内容。平台以"火辣但不露骨"为核心理念，严格把控内容尺度，确保所有擦边内容均在合法合规框架内，为用户提供安全、高品质的视觉娱乐体验。目前平台已积累超过 800 万活跃用户，每日更新 200+ 条精选擦边内容，涵盖街拍、热舞、图集、Cosplay 等多个热门品类。',
};

export const appContent = {
  title: '随时随地，火辣随身',
  subtitle: '下载爆料专区 App，擦边视频与擦边图片福利一手掌握',
  features: ['推送更及时，不错过任何劲爆内容', '离线缓存，无网络也能看', '专属 App 用户福利专区'],
};

export const contactContent = {
  title: '联系我们',
  subtitle: '投稿爆料 · 商务合作 · 问题反馈',
  email: 'contact@baoliao专区.com',
  wechat: 'baoliao_official',
  description: '如果你有好内容想投稿，或有商务合作需求，欢迎通过以下方式联系我们。我们期待你的加入！',
};

export const indexTopics = [
  { icon: 'ri-fire-line', title: '今日最热', desc: '每日热度最高的擦边视频合集', count: '128 条' },
  { icon: 'ri-image-line', title: '福利图集', desc: '高清擦边图片每日精选', count: '3,652 张' },
  { icon: 'ri-video-line', title: '擦边视频', desc: '劲爆尺度视频每日更新', count: '8,920 部' },
  { icon: 'ri-camera-line', title: '街拍精选', desc: '街头时尚擦边图片合集', count: '1,856 期' },
  { icon: 'ri-music-line', title: '热舞专区', desc: '女团风、韩系热舞视频', count: '2,430 部' },
  { icon: 'ri-user-smile-line', title: 'Cosplay', desc: '角色扮演擦边福利图集', count: '986 套' },
  { icon: 'ri-star-smile-line', title: '编辑精选', desc: '编辑团队严选精品内容', count: '520 期' },
  { icon: 'ri-trophy-line', title: '排行榜', desc: '全站热门内容实时排行', count: 'TOP 100' },
  { icon: 'ri-calendar-check-line', title: '每日更新', desc: '今天最新发布的擦边内容', count: '200+ 条' },
];

export const faqItems = [
  {
    q: '爆料专区的内容更新频率是怎样的？',
    a: '我们保持每日更新，编辑团队全天候筛选全网优质擦边视频与擦边图片，每天至少更新 200+ 条精选内容，确保你每次打开都有新发现。',
  },
  {
    q: '网站内容是否安全合规？',
    a: '绝对安全。爆料专区始终坚持"火辣但不露骨"的内容标准，所有擦边图片与视频均经过严格审核，确保在法律法规框架内运营，用户可以放心浏览。',
  },
  {
    q: '如何投稿自己的擦边视频或图片？',
    a: '欢迎投稿！你可以通过联系我们页面的邮箱或微信与我们取得联系，编辑团队审核通过后会在 24 小时内上线你的内容，并标注投稿者信息。',
  },
  {
    q: '爆料专区支持哪些设备访问？',
    a: '我们全面支持 PC 端、移动端网页访问，同时也提供 iOS 和 Android App 下载。无论你使用什么设备，都能获得流畅的浏览体验。',
  },
  {
    q: '如何第一时间收到最新内容推送？',
    a: '建议下载爆料专区 App 并开启推送通知，这样每当有新的劲爆擦边视频或福利图集上线时，你会第一时间收到提醒，绝不错过任何精彩。',
  },
];

export const topicTags = [
  { name: '擦边视频', count: '8.9k', hot: true },
  { name: '街拍合集', count: '6.2k', hot: true },
  { name: '热舞精选', count: '5.8k', hot: true },
  { name: '福利图集', count: '7.1k', hot: false },
  { name: '每日更新', count: '9.3k', hot: true },
  { name: 'Cosplay', count: '3.4k', hot: false },
  { name: '高清无水印', count: '4.6k', hot: false },
  { name: '夏日特辑', count: '2.8k', hot: true },
  { name: '网红精选', count: '5.1k', hot: false },
];

export const cardItems = [
  {
    title: '夏日清凉街拍特辑 · 第 90 期',
    desc: '本期限定夏日主题擦边图片合集，精选 88 张高清街拍福利图，每一张都是视觉盛宴。',
    tag: '街拍',
    image: 'https://readdy.ai/api/search-image?query=Fashionable%20summer%20street%20style%20photography%20with%20warm%20golden%20sunlight%2C%20trendy%20urban%20atmosphere%2C%20elegant%20casual%20fashion%20vibe%2C%20soft%20natural%20lighting%20on%20city%20streets%2C%20editorial%20quality%20with%20cream%20and%20warm%20beige%20tones&width=640&height=420&seq=card-01&orientation=landscape',
  },
  {
    title: '热舞精选 · 韩系女团风合集',
    desc: '韩系女团风擦边视频大合集，劲爆舞蹈动作全程高能，视觉冲击力拉满，速来围观。',
    tag: '热舞',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20stage%20performance%20with%20dramatic%20warm%20lighting%20in%20red%20and%20gold%20tones%2C%20energetic%20dance%20atmosphere%2C%20concert%20vibe%20with%20spotlights%2C%20artistic%20motion%20blur%20effect%2C%20exciting%20entertainment%20scene&width=640&height=420&seq=card-02&orientation=landscape',
  },
  {
    title: 'Cosplay 福利专区 · 人气角色合集',
    desc: '热门动漫游戏角色 Cosplay 擦边图片合集，还原度超高，福利满满，二次元爱好者必看。',
    tag: 'Cosplay',
    image: 'https://readdy.ai/api/search-image?query=Creative%20cosplay%20photography%20with%20vibrant%20costume%20colors%20and%20dramatic%20studio%20lighting%2C%20anime%20inspired%20character%20portrayal%20atmosphere%2C%20artistic%20composition%20with%20warm%20background%20tones%2C%20professional%20photography%20style&width=640&height=420&seq=card-03&orientation=landscape',
  },
  {
    title: '网红精选擦边图片 · 月度合集',
    desc: '本月最受欢迎网红擦边图片大合集，精选 20 位人气网红的高清福利图，一张都不能错过。',
    tag: '图集',
    image: 'https://readdy.ai/api/search-image?query=Glamorous%20fashion%20editorial%20photography%20with%20soft%20dreamy%20lighting%20in%20warm%20coral%20and%20rose%20tones%2C%20elegant%20studio%20setting%20with%20beautiful%20aesthetic%2C%20professional%20model%20photography%20atmosphere%2C%20luxurious%20and%20stylish%20vibe&width=640&height=420&seq=card-04&orientation=landscape',
  },
  {
    title: '擦边视频排行榜 · 本周 TOP 10',
    desc: '本周全站播放量最高的 10 部擦边视频，热舞、街拍、才艺展示应有尽有，速来补课。',
    tag: '视频',
    image: 'https://readdy.ai/api/search-image?query=Energetic%20entertainment%20show%20with%20vibrant%20neon%20stage%20lighting%20in%20hot%20pink%20and%20warm%20orange%2C%20dynamic%20performance%20atmosphere%2C%20exciting%20nightclub%20vibe%2C%20artistic%20light%20trails%20and%20bokeh%20effects%2C%20modern%20entertainment%20scene&width=640&height=420&seq=card-05&orientation=landscape',
  },
  {
    title: '每日福利 · 今日擦边图片合集',
    desc: '今日份擦边图片福利新鲜出炉，128 张高清无水印精选，日常必刷，每天都有新惊喜。',
    tag: '每日',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20beauty%20photography%20collection%20with%20warm%20natural%20sunlight%20streaming%20through%20windows%2C%20elegant%20and%20stylish%20composition%2C%20soft%20cream%20and%20peach%20color%20palette%2C%20editorial%20fashion%20quality%2C%20dreamy%20romantic%20atmosphere&width=640&height=420&seq=card-06&orientation=landscape',
  },
];

export const carouselItems = [
  {
    title: '🔥 夏日热浪 · 擦边视频特辑',
    desc: '夏日专属劲爆擦边视频大合集，全网最火辣内容一网打尽',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20warm%20sunset%20beach%20atmosphere%20with%20golden%20hour%20lighting%2C%20vibrant%20summer%20energy%2C%20artistic%20lens%20flare%20effect%2C%20stylish%20vacation%20vibe%2C%20beautiful%20scenic%20composition%20with%20warm%20orange%20and%20pink%20sky%20gradient%2C%20luxurious%20resort%20aesthetic&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '限时推荐',
  },
  {
    title: '📸 街拍精选 · 都市时尚图鉴',
    desc: '城市街头最真实的时尚擦边图片，每一帧都是大片质感',
    image: 'https://readdy.ai/api/search-image?query=Modern%20urban%20city%20street%20scene%20with%20warm%20afternoon%20lighting%2C%20fashionable%20cosmopolitan%20atmosphere%2C%20stylish%20architectural%20background%20with%20glass%20buildings%2C%20trendy%20metropolitan%20vibe%2C%20golden%20hour%20sunlight%20casting%20long%20shadows%2C%20editorial%20street%20photography&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '编辑精选',
  },
  {
    title: '💃 热舞天堂 · 韩流女团特供',
    desc: '韩系女团风擦边视频大合集，劲爆舞蹈动作让你挪不开眼',
    image: 'https://readdy.ai/api/search-image?query=Dazzling%20concert%20stage%20with%20dramatic%20spotlight%20beams%20in%20warm%20gold%20and%20amber%20tones%2C%20energetic%20performance%20atmosphere%2C%20dynamic%20stage%20smoke%20effects%2C%20large%20venue%20vibe%2C%20exciting%20live%20entertainment%20scene%2C%20professional%20stage%20lighting&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '热门推荐',
  },
  {
    title: '🎭 Cosplay 盛宴 · 次元壁破裂',
    desc: '人气角色 Cosplay 擦边图片福利合集，还原度爆表的视觉享受',
    image: 'https://readdy.ai/api/search-image?query=Creative%20anime%20cosplay%20photography%20with%20colorful%20vibrant%20costumes%20and%20dramatic%20studio%20lighting%2C%20fantasy%20atmosphere%20with%20warm%20ambient%20glow%2C%20artistic%20composition%2C%20professional%20photography%20with%20rich%20jewel%20tones%20and%20golden%20accents&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '专题推荐',
  },
  {
    title: '🏆 年度榜单 · 最受欢迎福利合集',
    desc: '年度最火辣擦边内容大盘点，播放量过亿的神级合集一次看过瘾',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20award%20ceremony%20atmosphere%20with%20elegant%20warm%20golden%20lighting%2C%20premium%20event%20setting%20with%20dramatic%20spotlights%2C%20sophisticated%20evening%20vibe%2C%20sparkling%20decorative%20elements%2C%20red%20carpet%20aesthetic%2C%20glamorous%20entertainment%20gala%20scene&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '年度精选',
  },
  {
    title: '🎁 新人福利 · 入门必看合集',
    desc: '新来的朋友看这里！编辑精选入门级擦边内容合集，打开新世界大门',
    image: 'https://readdy.ai/api/search-image?query=Warm%20welcoming%20atmosphere%20with%20soft%20golden%20evening%20lighting%2C%20elegant%20interior%20with%20cozy%20ambient%20glow%2C%20sophisticated%20lounge%20vibe%2C%20beautiful%20decorative%20lighting%20with%20warm%20candlelight%20tones%2C%20inviting%20and%20stylish%20atmosphere&width=800&height=500&seq=carousel-06&orientation=landscape',
    tag: '入门指南',
  },
];